module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CmsTemplate', {
    attrs: {
      "pageName": 'about',
      "pageTitle": _vm.$t('commons.about')
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ab600b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/AboutPage.vue
// module id = 751
// module chunks = 1